import { useCallback } from 'react';

import { useLocalStorage } from './useLocalStorage';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorageKeys';
import { SERVICES_URL } from '../constants/appsUrls';

export const useAuthActions = (
  options,
) => {
  const { remove: removeAuthToken } = useLocalStorage(
    LOCAL_STORAGE_KEYS.AUTH_TOKEN,
  );
  const { remove: removeRefreshToken } = useLocalStorage(
    LOCAL_STORAGE_KEYS.AUTH_REFRESH_TOKEN,
  );
  const { remove: removeIsAgent } = useLocalStorage(
    LOCAL_STORAGE_KEYS.AUTH_IS_AGENT,
  );

  const handleRedirectToLogin = useCallback(() => {
    options?.onRedirectLogin?.();

    const url = `${SERVICES_URL}/auth?redirect=/`;

    window.location.assign(url);
  }, [options]);

  const handleRedirectToRegister = useCallback(() => {
    options?.onRedirectRegister?.();

    const url = `${SERVICES_URL}/auth/registration`;
  
    window.location.assign(url);
  }, [options]);

  const handleLogout = useCallback(() => {
    options?.onLogout?.();

    removeAuthToken();
    removeRefreshToken();
    removeIsAgent();

    // It redirects to /auth/logout because it is outside the domain
    const url = `${SERVICES_URL}/auth/logout`;

    window.location.assign(url);
  }, [options, removeAuthToken, removeIsAgent, removeRefreshToken]);

  return { handleRedirectToLogin, handleRedirectToRegister, handleLogout };
};
